import _asyncToGenerator from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component, registerComponent, getOptions, getApplication, createNotificationReply, callNotificationWebhook, getCloudApiEnvironment, fetchDynamicLink } from '@notificare/web-core';
import { Logger } from '@notificare/web-logger';
import { createRoot, createBackdrop, createModal, createModalHeader, createModalContent, createModalFooter, createPrimaryButton, createSecondaryButton, createButton } from '@notificare/web-ui';
import { fetchCloudPass, fetchCloudPassSaveLinks } from '@notificare/web-cloud-api';
/* eslint-disable class-methods-use-this */

var PushUiComponent = /*#__PURE__*/function (_Component) {
  _inherits(PushUiComponent, _Component);

  var _super = _createSuper(PushUiComponent);

  function PushUiComponent() {
    _classCallCheck(this, PushUiComponent);

    return _super.call(this, 'push-ui');
  }

  _createClass(PushUiComponent, [{
    key: "configure",
    value: function configure() {//
    }
  }, {
    key: "launch",
    value: function () {
      var _launch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function launch() {
        return _launch.apply(this, arguments);
      }

      return launch;
    }()
  }, {
    key: "unlaunch",
    value: function () {
      var _unlaunch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function unlaunch() {
        return _unlaunch.apply(this, arguments);
      }

      return unlaunch;
    }()
  }]);

  return PushUiComponent;
}(Component);

function registerComponents() {
  registerComponent(new PushUiComponent());
}

var logger = new Logger('notificare/push-ui');
var notificationWillPresentCallback;
var notificationPresentedCallback;
var notificationFinishedPresentingCallback;
var notificationFailedToPresentCallback;
var actionWillExecuteCallback;
var actionExecutedCallback;
var actionFailedToExecuteCallback;
var customActionReceivedCallback;

function onNotificationWillPresent(callback) {
  notificationWillPresentCallback = callback;
  return {
    remove: function remove() {
      notificationWillPresentCallback = undefined;
    }
  };
}

function onNotificationPresented(callback) {
  notificationPresentedCallback = callback;
  return {
    remove: function remove() {
      notificationPresentedCallback = undefined;
    }
  };
}

function onNotificationFinishedPresenting(callback) {
  notificationFinishedPresentingCallback = callback;
  return {
    remove: function remove() {
      notificationFinishedPresentingCallback = undefined;
    }
  };
}

function onNotificationFailedToPresent(callback) {
  notificationFailedToPresentCallback = callback;
  return {
    remove: function remove() {
      notificationFailedToPresentCallback = undefined;
    }
  };
}

function onActionWillExecute(callback) {
  actionWillExecuteCallback = callback;
  return {
    remove: function remove() {
      actionWillExecuteCallback = undefined;
    }
  };
}

function onActionExecuted(callback) {
  actionExecutedCallback = callback;
  return {
    remove: function remove() {
      actionExecutedCallback = undefined;
    }
  };
}

function onActionFailedToExecute(callback) {
  actionFailedToExecuteCallback = callback;
  return {
    remove: function remove() {
      actionFailedToExecuteCallback = undefined;
    }
  };
}

function onCustomActionReceived(callback) {
  customActionReceivedCallback = callback;
  return {
    remove: function remove() {
      customActionReceivedCallback = undefined;
    }
  };
}

function notifyNotificationWillPresent(notification) {
  var callback = notificationWillPresentCallback;

  if (!callback) {
    logger.debug("The 'notification_will_present' handler is not configured.");
    return;
  }

  callback(notification);
}

function notifyNotificationPresented(notification) {
  var callback = notificationPresentedCallback;

  if (!callback) {
    logger.debug("The 'notification_presented' handler is not configured.");
    return;
  }

  callback(notification);
}

function notifyNotificationFinishedPresenting(notification) {
  var callback = notificationFinishedPresentingCallback;

  if (!callback) {
    logger.debug("The 'notification_finished_presenting' handler is not configured.");
    return;
  }

  callback(notification);
}

function notifyNotificationFailedToPresent(notification) {
  var callback = notificationFailedToPresentCallback;

  if (!callback) {
    logger.debug("The 'notification_failed_to_present' handler is not configured.");
    return;
  }

  callback(notification);
}

function notifyActionWillExecute(notification, action) {
  var callback = actionWillExecuteCallback;

  if (!callback) {
    logger.debug("The 'action_will_execute' handler is not configured.");
    return;
  }

  callback(notification, action);
}

function notifyActionExecuted(notification, action) {
  var callback = actionExecutedCallback;

  if (!callback) {
    logger.debug("The 'action_executed' handler is not configured.");
    return;
  }

  callback(notification, action);
}

function notifyActionFailedToExecute(notification, action) {
  var callback = actionFailedToExecuteCallback;

  if (!callback) {
    logger.debug("The 'action_failed_to_execute' handler is not configured.");
    return;
  }

  callback(notification, action);
}

function notifyCustomActionReceived(notification, action, target) {
  var callback = customActionReceivedCallback;

  if (!callback) {
    logger.debug("The 'custom_action_received' handler is not configured.");
    return;
  }

  callback(notification, action, target);
}

function getEmailUrl(email) {
  return prefixed(email, 'mailto:');
}

function getSmsUrl(phoneNumber) {
  return prefixed(phoneNumber, 'sms:');
}

function getTelephoneUrl(phoneNumber) {
  return prefixed(phoneNumber, 'tel:');
}

function prefixed(value, prefix) {
  if (value.startsWith(prefix)) return value;
  return "".concat(prefix).concat(value);
}

function getApplicationIcon() {
  var _a, _b;

  var options = getOptions();
  if (!options) return undefined;
  var icon = (_b = (_a = getApplication()) === null || _a === void 0 ? void 0 : _a.websitePushConfig) === null || _b === void 0 ? void 0 : _b.icon;
  if (!icon) return undefined;
  return "https://".concat(options.hosts.restApi, "/upload").concat(icon);
}

function getApplicationName() {
  var _a;

  return (_a = getApplication()) === null || _a === void 0 ? void 0 : _a.name;
}

var ROOT_ELEMENT_IDENTIFIER = 'notificare-push-ui';

function ensureCleanState() {
  var root = document.getElementById(ROOT_ELEMENT_IDENTIFIER);
  if (root) root.remove();
}

function createCameraCallbackModal(_ref) {
  var hasMoreSteps = _ref.hasMoreSteps,
      onMediaCaptured = _ref.onMediaCaptured,
      dismiss = _ref.dismiss;
  var root = createRoot(ROOT_ELEMENT_IDENTIFIER);
  root.appendChild(createBackdrop(function () {
    return dismiss();
  }));
  var modal = root.appendChild(createModal());
  modal.classList.add('notificare__camera-callback');
  modal.appendChild(createModalHeader({
    icon: getApplicationIcon(),
    title: getApplicationName(),
    onCloseButtonClicked: function onCloseButtonClicked() {
      return dismiss();
    }
  }));
  var content = modal.appendChild(createModalContent());
  var video = content.appendChild(document.createElement('video'));
  video.classList.add('notificare__camera-callback-video');
  video.setAttribute('autoplay', '');
  createVideoStream().then(function (stream) {
    video.srcObject = stream;
  }).catch(function (error) {
    return logger.error('Unable to acquire a video stream.', error);
  });
  var canvas = document.createElement('canvas');
  canvas.classList.add('notificare__camera-callback-canvas');
  var footer = modal.appendChild(createModalFooter());
  footer.classList.add('notificare__modal-footer__callback');
  var takePictureButton = footer.appendChild(createPrimaryButton({
    text: 'Take picture',
    onClick: function onClick() {
      var _a;

      var canvasContext = canvas.getContext('2d');

      if (!canvasContext) {
        logger.warning('The Canvas API is not available.');
        return;
      } // Draw the video stream onto the canvas.


      canvasContext.drawImage(video, 0, 0, canvas.width, canvas.height); // Stop the video stream.

      var stream = video.srcObject;
      (_a = stream === null || stream === void 0 ? void 0 : stream.getTracks()) === null || _a === void 0 ? void 0 : _a.forEach(function (track) {
        return track.stop();
      });
      video.srcObject = null;
      content.removeChild(video);
      content.appendChild(canvas);
      footer.removeChild(takePictureButton);
      footer.appendChild(retakePictureButton);
      footer.appendChild(sendButton);
    }
  }));
  var retakePictureButton = createSecondaryButton({
    text: 'Retake picture',
    onClick: function onClick() {
      content.removeChild(canvas);
      content.appendChild(video);
      createVideoStream().then(function (stream) {
        video.srcObject = stream;
      }).catch(function (error) {
        return logger.error('Unable to acquire a video stream.', error);
      });
      footer.removeChild(retakePictureButton);
      footer.removeChild(sendButton);
      footer.appendChild(takePictureButton);
    }
  });
  var sendButton = createPrimaryButton({
    text: hasMoreSteps ? 'Continue' : 'Send',
    onClick: function onClick() {
      canvas.toBlob(function (blob) {
        if (!blob) {
          logger.warning('Unable to create a blob to upload.');
          return;
        }

        onMediaCaptured(blob, 'image/jpg');
      }, 'image/jpg');
    }
  });
  return root;
}

function createVideoStream() {
  return _createVideoStream.apply(this, arguments);
}

function _createVideoStream() {
  _createVideoStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var supported;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            supported = 'mediaDevices' in navigator;

            if (supported) {
              _context5.next = 3;
              break;
            }

            throw new Error('WebRTC API unavailable.');

          case 3:
            return _context5.abrupt("return", navigator.mediaDevices.getUserMedia({
              video: {
                width: 1280,
                height: 720
              }
            }));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _createVideoStream.apply(this, arguments);
}

function createKeyboardCallbackModal(_ref2) {
  var dismiss = _ref2.dismiss,
      onTextCaptured = _ref2.onTextCaptured;
  var root = createRoot(ROOT_ELEMENT_IDENTIFIER);
  root.appendChild(createBackdrop(function () {
    return dismiss();
  }));
  var modal = root.appendChild(createModal());
  modal.classList.add('notificare__keyboard-callback');
  modal.appendChild(createModalHeader({
    icon: getApplicationIcon(),
    title: getApplicationName(),
    onCloseButtonClicked: function onCloseButtonClicked() {
      return dismiss();
    }
  }));
  var content = modal.appendChild(createModalContent());
  var textarea = content.appendChild(document.createElement('textarea'));
  textarea.classList.add('notificare__keyboard-callback-textarea');
  textarea.setAttribute('placeholder', 'Type something...'); // textarea.addEventListener('input', () => onTextChange(textarea.value));

  var footer = modal.appendChild(createModalFooter());
  footer.classList.add('notificare__modal-footer__callback');
  footer.appendChild(createPrimaryButton({
    text: 'Send',
    onClick: function onClick() {
      onTextCaptured(textarea.value);
    }
  }));
  return root;
}

function presentAction$1(notification, action) {
  ensureCleanState();
  presentActionAsync(notification, action).catch(function (e) {
    return logger.error('Failed to present action.', e);
  });
}

function presentActionAsync(_x, _x2) {
  return _presentActionAsync.apply(this, arguments);
}

function _presentActionAsync() {
  _presentActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(notification, action) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            logger.debug("Presenting action '".concat(action.type, "' for notification '").concat(notification.id, "'."));
            notifyActionWillExecute(notification, action);

            if (!shouldTrackReplyBeforePresenting(action)) {
              _context6.next = 5;
              break;
            }

            _context6.next = 5;
            return createNotificationReply(notification, action);

          case 5:
            _context6.prev = 5;
            _context6.t0 = action.type;
            _context6.next = _context6.t0 === 're.notifica.action.App' ? 9 : _context6.t0 === 're.notifica.action.Browser' ? 12 : _context6.t0 === 're.notifica.action.Callback' ? 15 : _context6.t0 === 're.notifica.action.Custom' ? 18 : _context6.t0 === 're.notifica.action.InAppBrowser' ? 21 : _context6.t0 === 're.notifica.action.Mail' ? 24 : _context6.t0 === 're.notifica.action.SMS' ? 27 : _context6.t0 === 're.notifica.action.Telephone' ? 30 : 33;
            break;

          case 9:
            _context6.next = 11;
            return presentApp(action);

          case 11:
            return _context6.abrupt("break", 34);

          case 12:
            _context6.next = 14;
            return presentBrowser(action);

          case 14:
            return _context6.abrupt("break", 34);

          case 15:
            _context6.next = 17;
            return presentCallback(notification, action);

          case 17:
            return _context6.abrupt("break", 34);

          case 18:
            _context6.next = 20;
            return presentCustom(notification, action);

          case 20:
            return _context6.abrupt("break", 34);

          case 21:
            _context6.next = 23;
            return presentInAppBrowser$1(action);

          case 23:
            return _context6.abrupt("break", 34);

          case 24:
            _context6.next = 26;
            return presentMail(action);

          case 26:
            return _context6.abrupt("break", 34);

          case 27:
            _context6.next = 29;
            return presentSms(action);

          case 29:
            return _context6.abrupt("break", 34);

          case 30:
            _context6.next = 32;
            return presentTelephone(action);

          case 32:
            return _context6.abrupt("break", 34);

          case 33:
            throw new Error("Unsupported action type '".concat(action.type, "'."));

          case 34:
            if (!requiresUserInteraction(action)) {
              _context6.next = 36;
              break;
            }

            return _context6.abrupt("return");

          case 36:
            if (shouldTrackReplyBeforePresenting(action)) {
              _context6.next = 39;
              break;
            }

            _context6.next = 39;
            return createNotificationReply(notification, action);

          case 39:
            notifyActionExecuted(notification, action);
            _context6.next = 46;
            break;

          case 42:
            _context6.prev = 42;
            _context6.t1 = _context6["catch"](5);
            logger.error('Failed to present action.', _context6.t1);
            notifyActionFailedToExecute(notification, action);

          case 46:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[5, 42]]);
  }));
  return _presentActionAsync.apply(this, arguments);
}

function shouldTrackReplyBeforePresenting(action) {
  switch (action.type) {
    case 're.notifica.action.App':
    case 're.notifica.action.Browser':
    case 're.notifica.action.InAppBrowser':
      return true;

    default:
      return false;
  }
}

function requiresUserInteraction(action) {
  return action.type === 're.notifica.action.Callback' && (action.camera || action.keyboard);
}

function presentApp(_x3) {
  return _presentApp.apply(this, arguments);
}

function _presentApp() {
  _presentApp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(action) {
    var _a;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            window.location.href = ((_a = action.target) === null || _a === void 0 ? void 0 : _a.trim()) ? action.target.trim() : '/';

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _presentApp.apply(this, arguments);
}

function presentBrowser(_x4) {
  return _presentBrowser.apply(this, arguments);
}

function _presentBrowser() {
  _presentBrowser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(action) {
    var _a;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            window.location.href = ((_a = action.target) === null || _a === void 0 ? void 0 : _a.trim()) ? action.target.trim() : '/';

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _presentBrowser.apply(this, arguments);
}

function presentCallback(_x5, _x6) {
  return _presentCallback.apply(this, arguments);
}

function _presentCallback() {
  _presentCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(notification, action) {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (action.camera && action.keyboard) {
              // Show the camera UI.
              document.body.appendChild(createCameraCallbackModal({
                hasMoreSteps: true,
                onMediaCaptured: function onMediaCaptured(media, mimeType) {
                  ensureCleanState(); // Show the keyboard UI.

                  document.body.appendChild(createKeyboardCallbackModal({
                    dismiss: function dismiss() {
                      return ensureCleanState();
                    },
                    onTextCaptured: function onTextCaptured(text) {
                      processCallbackResult(notification, action, {
                        message: text,
                        media: media,
                        mimeType: mimeType
                      }).catch(function (e) {
                        return logger.error('Failed to process the notification reply.', e);
                      });
                    }
                  }));
                },
                dismiss: function dismiss() {
                  return ensureCleanState();
                }
              }));
            } else if (action.camera) {
              // Show the camera UI.
              document.body.appendChild(createCameraCallbackModal({
                hasMoreSteps: false,
                onMediaCaptured: function onMediaCaptured(media, mimeType) {
                  processCallbackResult(notification, action, {
                    media: media,
                    mimeType: mimeType
                  }).catch(function (e) {
                    return logger.error('Failed to process the notification reply.', e);
                  });
                },
                dismiss: function dismiss() {
                  return ensureCleanState();
                }
              }));
            } else if (action.keyboard) {
              // Show the keyboard UI.
              document.body.appendChild(createKeyboardCallbackModal({
                dismiss: function dismiss() {
                  return ensureCleanState();
                },
                onTextCaptured: function onTextCaptured(text) {
                  processCallbackResult(notification, action, {
                    message: text
                  }).catch(function (e) {
                    return logger.error('Failed to process the notification reply.', e);
                  });
                }
              }));
            } else {
              processCallbackResult(notification, action).catch(function (e) {
                return logger.error('Failed to process the notification reply.', e);
              });
            }

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _presentCallback.apply(this, arguments);
}

function processCallbackResult(_x7, _x8, _x9) {
  return _processCallbackResult.apply(this, arguments);
}

function _processCallbackResult() {
  _processCallbackResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(notification, action, data) {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;

            if (!action.target) {
              _context10.next = 4;
              break;
            }

            _context10.next = 4;
            return callNotificationWebhook(notification, action);

          case 4:
            if (!requiresUserInteraction(action)) {
              _context10.next = 7;
              break;
            }

            _context10.next = 7;
            return createNotificationReply(notification, action, data);

          case 7:
            notifyActionExecuted(notification, action);
            _context10.next = 13;
            break;

          case 10:
            _context10.prev = 10;
            _context10.t0 = _context10["catch"](0);
            notifyActionFailedToExecute(notification, action);

          case 13:
            ensureCleanState();

          case 14:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 10]]);
  }));
  return _processCallbackResult.apply(this, arguments);
}

function presentCustom(_x10, _x11) {
  return _presentCustom.apply(this, arguments);
}

function _presentCustom() {
  _presentCustom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(notification, action) {
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (action.target) {
              _context11.next = 2;
              break;
            }

            throw new Error('Invalid action target.');

          case 2:
            notifyCustomActionReceived(notification, action, action.target);

          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _presentCustom.apply(this, arguments);
}

function presentInAppBrowser$1(_x12) {
  return _presentInAppBrowser$.apply(this, arguments);
}

function _presentInAppBrowser$() {
  _presentInAppBrowser$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(action) {
    var _a;

    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            window.location.href = ((_a = action.target) === null || _a === void 0 ? void 0 : _a.trim()) ? action.target.trim() : '/';

          case 1:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _presentInAppBrowser$.apply(this, arguments);
}

function presentMail(_x13) {
  return _presentMail.apply(this, arguments);
}

function _presentMail() {
  _presentMail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(action) {
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (action.target) {
              _context13.next = 2;
              break;
            }

            throw new Error('Invalid action target.');

          case 2:
            window.location.href = getEmailUrl(action.target);

          case 3:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _presentMail.apply(this, arguments);
}

function presentSms(_x14) {
  return _presentSms.apply(this, arguments);
}

function _presentSms() {
  _presentSms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(action) {
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (action.target) {
              _context14.next = 2;
              break;
            }

            throw new Error('Invalid action target.');

          case 2:
            window.location.href = getSmsUrl(action.target);

          case 3:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _presentSms.apply(this, arguments);
}

function presentTelephone(_x15) {
  return _presentTelephone.apply(this, arguments);
}

function _presentTelephone() {
  _presentTelephone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(action) {
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            if (action.target) {
              _context15.next = 2;
              break;
            }

            throw new Error('Invalid action target.');

          case 2:
            window.location.href = getTelephoneUrl(action.target);

          case 3:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _presentTelephone.apply(this, arguments);
}

function resolveUrl(notification) {
  var content = notification.content.find(function (_ref3) {
    var type = _ref3.type;
    return type === 're.notifica.content.URL';
  });
  if (!content || !content.data) return UrlResolverResult.NONE;
  var isStringContent = typeof content.data === 'string' || content.data instanceof String;
  if (!isStringContent) return UrlResolverResult.NONE;
  var urlStr = content.data.toString().trim();
  if (!urlStr) return UrlResolverResult.NONE;
  if (urlStr.startsWith('/')) return UrlResolverResult.IN_APP_BROWSER;
  var url;

  try {
    url = new URL(urlStr);
  } catch (e) {
    return UrlResolverResult.NONE;
  }

  var isHttpUrl = url.protocol === 'http:' || url.protocol === 'https:';
  var isDynamicLink = url.host.endsWith('ntc.re');
  if (!isHttpUrl || isDynamicLink) return UrlResolverResult.URL_SCHEME;
  var webViewQueryParameter = url.searchParams.get('notificareWebView');
  var isWebViewMode = webViewQueryParameter === '1' || (webViewQueryParameter === null || webViewQueryParameter === void 0 ? void 0 : webViewQueryParameter.toLowerCase()) === 'true';
  return isWebViewMode ? UrlResolverResult.WEB_VIEW : UrlResolverResult.IN_APP_BROWSER;
}

var UrlResolverResult;

(function (UrlResolverResult) {
  UrlResolverResult[UrlResolverResult["NONE"] = 0] = "NONE";
  UrlResolverResult[UrlResolverResult["URL_SCHEME"] = 1] = "URL_SCHEME";
  UrlResolverResult[UrlResolverResult["IN_APP_BROWSER"] = 2] = "IN_APP_BROWSER";
  UrlResolverResult[UrlResolverResult["WEB_VIEW"] = 3] = "WEB_VIEW";
})(UrlResolverResult || (UrlResolverResult = {}));

function isAppleDevice() {
  var expression = /Mac|iPhone|iPod|iPad/i;
  return expression.test(navigator.userAgent);
}

function isChromeBrowser() {
  var expression = /Chrome/i;
  return expression.test(navigator.userAgent);
}

function isSafariBrowser() {
  var expression = /Safari/i;
  return expression.test(navigator.userAgent) && !isChromeBrowser();
}

function sanitizeContentUrl(content) {
  var _a;

  var url = (_a = content.data) === null || _a === void 0 ? void 0 : _a.trim();
  if (!url) return '/';

  try {
    var parsedUrl = new URL(url); // The URLResolver type may include an auxiliary notificareWebView parameter.
    // Remove it from the destination URL.

    parsedUrl.searchParams.delete('notificareWebView');
    return parsedUrl.toString();
  } catch (_b) {
    return url;
  }
}

function createAlertContent(_x16) {
  return _createAlertContent.apply(this, arguments);
}

function _createAlertContent() {
  _createAlertContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(notification) {
    var container, attachment, title, subtitle, message;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            container = document.createElement('div');
            container.classList.add('notificare__notification-alert');
            attachment = createAttachmentSection(notification);
            if (attachment) container.appendChild(attachment);

            if (notification.title) {
              title = container.appendChild(document.createElement('p'));
              title.classList.add('notificare__notification-alert-title');
              title.innerHTML = notification.title;
            }

            if (notification.subtitle) {
              subtitle = container.appendChild(document.createElement('p'));
              subtitle.classList.add('notificare__notification-content-subtitle');
              subtitle.innerHTML = notification.subtitle;
            }

            message = container.appendChild(document.createElement('p'));
            message.classList.add('notificare__notification-alert-message');
            message.innerHTML = notification.message;
            return _context16.abrupt("return", container);

          case 10:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _createAlertContent.apply(this, arguments);
}

function createAttachmentSection(notification) {
  var attachment = notification.attachments.find(function (_ref4) {
    var mimeType = _ref4.mimeType;
    return /image/.test(mimeType);
  });
  if (!attachment) return undefined;
  var element = document.createElement('img');
  element.classList.add('notificare__notification-alert-attachment');
  element.setAttribute('src', attachment.uri);
  return element;
}

function createImageContent(_x17) {
  return _createImageContent.apply(this, arguments);
}

function _createImageContent() {
  _createImageContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(notification) {
    var allowedContentTypes, content, slider;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            allowedContentTypes = ['re.notifica.content.JPEG', 're.notifica.content.JPG', 're.notifica.content.PNG', 're.notifica.content.GIF'];
            content = notification.content.filter(function (_ref7) {
              var type = _ref7.type;
              return allowedContentTypes.includes(type);
            });

            if (content.length) {
              _context17.next = 4;
              break;
            }

            throw new Error("Invalid content for notification '".concat(notification.type, "'."));

          case 4:
            slider = document.createElement('div');
            slider.classList.add('notificare__notification-image-slider');
            content.forEach(function (element) {
              var item = document.createElement('div');
              item.classList.add('notificare__notification-image-slider-item');
              slider.appendChild(item);
              var image = document.createElement('img');
              image.classList.add('notificare__notification-image-slider-image');
              image.setAttribute('src', element.data);
              item.appendChild(image);
            });
            return _context17.abrupt("return", slider);

          case 8:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _createImageContent.apply(this, arguments);
}

function createMapContent(_x18) {
  return _createMapContent.apply(this, arguments);
}

function _createMapContent() {
  _createMapContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(notification) {
    var content, mapContainer, _yield$google$maps$im, Map, map, markers, bounds;

    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            content = notification.content.filter(function (_ref8) {
              var type = _ref8.type;
              return type === 're.notifica.content.Marker';
            });

            if (content.length) {
              _context18.next = 3;
              break;
            }

            throw new Error("Invalid content for notification '".concat(notification.type, "'."));

          case 3:
            if (!(typeof window.google === 'undefined' || !google || !google.maps)) {
              _context18.next = 5;
              break;
            }

            throw new Error('Google Maps library could not be found.');

          case 5:
            mapContainer = document.createElement('div');
            mapContainer.classList.add('notificare__notification-map'); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore

            _context18.next = 9;
            return google.maps.importLibrary('maps');

          case 9:
            _yield$google$maps$im = _context18.sent;
            Map = _yield$google$maps$im.Map;
            map = new Map(mapContainer, {
              zoom: 15,
              center: {
                lat: content[0].data.latitude,
                lng: content[0].data.longitude
              }
            });
            markers = content.map(function (_ref9) {
              var data = _ref9.data;
              var marker = new google.maps.Marker({
                map: map,
                position: {
                  lat: data.latitude,
                  lng: data.longitude
                }
              });

              if (data.title || data.description) {
                var infoWindowContent = document.createElement('div');
                infoWindowContent.classList.add('notificare__notification-map-info-window');

                if (data.title) {
                  var title = document.createElement('h2');
                  title.classList.add('notificare__notification-map-info-window-title');
                  title.innerHTML = data.title;
                  infoWindowContent.appendChild(title);
                }

                if (data.description) {
                  var description = document.createElement('p');
                  description.classList.add('notificare__notification-map-info-window-description');
                  description.innerHTML = data.description;
                  infoWindowContent.appendChild(description);
                }

                var infoWindow = new google.maps.InfoWindow({
                  content: infoWindowContent
                });
                marker.addListener('click', function () {
                  infoWindow.open({
                    anchor: marker,
                    map: map
                  });
                });
              }

              return marker;
            });

            if (markers.length > 1) {
              bounds = new google.maps.LatLngBounds();
              markers.forEach(function (marker) {
                var position = marker.getPosition();
                if (position) bounds.extend(position);
              });
              map.fitBounds(bounds);
            }

            return _context18.abrupt("return", mapContainer);

          case 15:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _createMapContent.apply(this, arguments);
}

function createUrlContent(_x19) {
  return _createUrlContent.apply(this, arguments);
}

function _createUrlContent() {
  _createUrlContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(notification) {
    var content, url, iframe;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            content = notification.content.find(function (_ref10) {
              var type = _ref10.type;
              return type === 're.notifica.content.URL';
            });

            if (content) {
              _context19.next = 3;
              break;
            }

            throw new Error("Invalid content for notification '".concat(notification.type, "'."));

          case 3:
            url = sanitizeContentUrl(content);
            iframe = document.createElement('iframe');
            iframe.classList.add('notificare__notification-url-iframe');
            iframe.setAttribute('src', url);
            return _context19.abrupt("return", iframe);

          case 8:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _createUrlContent.apply(this, arguments);
}

function createVideoContent(_x20) {
  return _createVideoContent.apply(this, arguments);
}

function _createVideoContent() {
  _createVideoContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(notification) {
    var allowedVideoTypes, content;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            allowedVideoTypes = ['re.notifica.content.YouTube', 're.notifica.content.Vimeo', 're.notifica.content.HTML5Video'];
            content = notification.content.find(function (_ref11) {
              var type = _ref11.type;
              return allowedVideoTypes.includes(type);
            });

            if (content) {
              _context20.next = 4;
              break;
            }

            throw new Error("Invalid content for notification '".concat(notification.type, "'."));

          case 4:
            _context20.t0 = content.type;
            _context20.next = _context20.t0 === 're.notifica.content.YouTube' ? 7 : _context20.t0 === 're.notifica.content.Vimeo' ? 8 : _context20.t0 === 're.notifica.content.HTML5Video' ? 9 : 10;
            break;

          case 7:
            return _context20.abrupt("return", createYouTubeContent(content.data));

          case 8:
            return _context20.abrupt("return", createVimeoContent(content.data));

          case 9:
            return _context20.abrupt("return", createHtml5VideoContent(content.data));

          case 10:
            throw new Error("Unsupported video type: ".concat(content.type));

          case 11:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _createVideoContent.apply(this, arguments);
}

function createYouTubeContent(videoId) {
  var iframe = document.createElement('iframe');
  iframe.classList.add('notificare__notification-video-iframe');
  iframe.setAttribute('src', "https://www.youtube-nocookie.com/embed/".concat(videoId, "?autoplay=1&rel=0"));
  iframe.setAttribute('allowfullscreen', '');
  return iframe;
}

function createVimeoContent(videoId) {
  var iframe = document.createElement('iframe');
  iframe.classList.add('notificare__notification-video-iframe');
  iframe.setAttribute('src', "https://player.vimeo.com/video/".concat(videoId, "?autoplay=1"));
  iframe.setAttribute('allowfullscreen', '');
  return iframe;
}

function createHtml5VideoContent(videoUrl) {
  var video = document.createElement('video');
  video.classList.add('notificare__notification-video');
  video.setAttribute('autoplay', '');
  video.setAttribute('controls', '');
  video.setAttribute('preload', '');
  var source = document.createElement('source');
  source.setAttribute('src', videoUrl);
  source.setAttribute('type', 'video/mp4');
  video.appendChild(source);
  return video;
}

function createWebViewContent(_x21) {
  return _createWebViewContent.apply(this, arguments);
}

function _createWebViewContent() {
  _createWebViewContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(notification) {
    var content, html, iframe;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            content = notification.content.find(function (_ref12) {
              var type = _ref12.type;
              return type === 're.notifica.content.HTML';
            });

            if (content) {
              _context21.next = 3;
              break;
            }

            throw new Error("Invalid content for notification '".concat(notification.type, "'."));

          case 3:
            html = "<!DOCTYPE html><html><head><title></title><meta name=\"viewport\" content=\"width=device-width, maximum-scale=1, initial-scale=1, user-scalable=0\"></head><body>".concat(content.data, "</body></html>");
            iframe = document.createElement('iframe');
            iframe.classList.add('notificare__notification-webview-iframe');
            iframe.setAttribute('srcdoc', html);
            return _context21.abrupt("return", iframe);

          case 8:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _createWebViewContent.apply(this, arguments);
}

function createNotificationModal(_x22) {
  return _createNotificationModal.apply(this, arguments);
}

function _createNotificationModal() {
  _createNotificationModal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_ref5) {
    var notification, dismiss, presentAction, root, modal, content, footer;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            notification = _ref5.notification, dismiss = _ref5.dismiss, presentAction = _ref5.presentAction;
            root = createRoot(ROOT_ELEMENT_IDENTIFIER);
            root.appendChild(createBackdrop(function () {
              return dismiss();
            }));
            modal = root.appendChild(createModal());
            modal.classList.add('notificare__notification');
            modal.setAttribute('data-notification-type', notification.type);
            modal.appendChild(createModalHeader({
              icon: getApplicationIcon(),
              title: getApplicationName(),
              onCloseButtonClicked: function onCloseButtonClicked() {
                return dismiss();
              }
            }));
            content = modal.appendChild(createModalContent());
            _context22.t0 = content;
            _context22.next = 11;
            return createContentContainer(notification);

          case 11:
            _context22.t1 = _context22.sent;

            _context22.t0.appendChild.call(_context22.t0, _context22.t1);

            if (notification.actions.length) {
              footer = modal.appendChild(createModalFooter());
              footer.appendChild(createActionsContainer(notification, function (action) {
                return presentAction(action);
              }));
            }

            return _context22.abrupt("return", root);

          case 15:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _createNotificationModal.apply(this, arguments);
}

function createContentContainer(_x23) {
  return _createContentContainer.apply(this, arguments);
}

function _createContentContainer() {
  _createContentContainer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(notification) {
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.t0 = notification.type;
            _context23.next = _context23.t0 === 're.notifica.notification.Alert' ? 3 : _context23.t0 === 're.notifica.notification.Image' ? 4 : _context23.t0 === 're.notifica.notification.Map' ? 5 : _context23.t0 === 're.notifica.notification.URL' ? 6 : _context23.t0 === 're.notifica.notification.URLResolver' ? 7 : _context23.t0 === 're.notifica.notification.Video' ? 8 : _context23.t0 === 're.notifica.notification.WebView' ? 9 : 10;
            break;

          case 3:
            return _context23.abrupt("return", createAlertContent(notification));

          case 4:
            return _context23.abrupt("return", createImageContent(notification));

          case 5:
            return _context23.abrupt("return", createMapContent(notification));

          case 6:
            return _context23.abrupt("return", createUrlContent(notification));

          case 7:
            return _context23.abrupt("return", createUrlContent(notification));

          case 8:
            return _context23.abrupt("return", createVideoContent(notification));

          case 9:
            return _context23.abrupt("return", createWebViewContent(notification));

          case 10:
            throw new Error("Unsupported notification type: ".concat(notification.type));

          case 11:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _createContentContainer.apply(this, arguments);
}

function createActionsContainer(notification, onActionClick) {
  var container = document.createElement('div');
  container.classList.add('notificare__notification-actions');

  if (notification.actions.length >= 3) {
    container.classList.add('notificare__notification-actions__list');
  }

  notification.actions.forEach(function (action, index) {
    container.appendChild(createButton({
      variant: index === 0 ? 'primary' : 'secondary',
      text: action.label,
      onClick: function onClick() {
        return onActionClick(action);
      }
    }));
  });
  return container;
}

var NotificationPresenter = /*#__PURE__*/function () {
  function NotificationPresenter() {
    _classCallCheck(this, NotificationPresenter);
  }

  _createClass(NotificationPresenter, [{
    key: "present",
    value: function present(notification) {
      ensureCleanState();
      notifyNotificationWillPresent(notification); // const application = getApplication();
      // if (!application) {
      //   logger.warning('Unable to present the notification. The cached application is unavailable.');
      //   notifyNotificationFailedToPresent(notification);
      //   return;
      // }

      var options = getOptions();

      if (!options) {
        logger.warning('Unable to present the notification. Notificare is not configured.');
        notifyNotificationFailedToPresent(notification);
        return;
      }

      if (!checkNotificationSupport(notification)) {
        logger.warning("Unable to present the notification. Unsupported notification type '".concat(notification.type, "'."));
        notifyNotificationFailedToPresent(notification);
        return;
      }

      logger.debug("Presenting notification '".concat(notification.id, "'."));
      this.notification = notification;
      this.presentNotification(notification, options).then(function () {
        notifyNotificationPresented(notification);
      }).catch(function (error) {
        logger.error('Failed to present a notification: ', error);
        notifyNotificationFailedToPresent(notification);
      });
    }
  }, {
    key: "dismiss",
    value: function dismiss() {
      if (this.notification) {
        notifyNotificationFinishedPresenting(this.notification);
      }

      this.notification = undefined;
      ensureCleanState();
    }
  }, {
    key: "presentNotification",
    value: function () {
      var _presentNotification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(notification, options) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = notification.type;
                _context3.next = _context3.t0 === 're.notifica.notification.None' ? 3 : _context3.t0 === 're.notifica.notification.InAppBrowser' ? 5 : _context3.t0 === 're.notifica.notification.URLResolver' ? 7 : _context3.t0 === 're.notifica.notification.URLScheme' ? 26 : _context3.t0 === 're.notifica.notification.Passbook' ? 29 : 32;
                break;

              case 3:
                logger.debug("Attempting to present a notification of type 'none'. These should be handled by the application instead.");
                return _context3.abrupt("return");

              case 5:
                presentInAppBrowser(notification);
                return _context3.abrupt("return");

              case 7:
                result = resolveUrl(notification);
                _context3.t1 = result;
                _context3.next = _context3.t1 === UrlResolverResult.NONE ? 11 : _context3.t1 === UrlResolverResult.URL_SCHEME ? 13 : _context3.t1 === UrlResolverResult.IN_APP_BROWSER ? 17 : _context3.t1 === UrlResolverResult.WEB_VIEW ? 20 : 24;
                break;

              case 11:
                logger.debug("Resolving as 'none' notification.");
                return _context3.abrupt("break", 25);

              case 13:
                logger.debug("Resolving as 'url scheme' notification.");
                _context3.next = 16;
                return presentUrlScheme(notification);

              case 16:
                return _context3.abrupt("break", 25);

              case 17:
                logger.debug("Resolving as 'in-app browser' notification.");
                presentInAppBrowser(notification);
                return _context3.abrupt("break", 25);

              case 20:
                logger.debug("Resolving as 'web view' notification.");
                _context3.next = 23;
                return this.showNotificationModal(notification);

              case 23:
                return _context3.abrupt("break", 25);

              case 24:
                throw new Error("Unknown URL resolver result '".concat(result, "'."));

              case 25:
                return _context3.abrupt("return");

              case 26:
                _context3.next = 28;
                return presentUrlScheme(notification);

              case 28:
                return _context3.abrupt("return");

              case 29:
                _context3.next = 31;
                return presentPassbook(options, notification);

              case 31:
                return _context3.abrupt("return");

              case 32:
                _context3.next = 34;
                return this.showNotificationModal(notification);

              case 34:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function presentNotification(_x24, _x25) {
        return _presentNotification.apply(this, arguments);
      }

      return presentNotification;
    }()
  }, {
    key: "showNotificationModal",
    value: function () {
      var _showNotificationModal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(notification) {
        var _this = this;

        var ui;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return createNotificationModal({
                  notification: notification,
                  dismiss: function dismiss() {
                    return _this.dismiss();
                  },
                  presentAction: function presentAction(action) {
                    _this.dismiss();

                    presentAction$1(notification, action);
                  }
                });

              case 2:
                ui = _context4.sent;
                // Add the complete notification DOM to the page.
                document.body.appendChild(ui);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function showNotificationModal(_x26) {
        return _showNotificationModal.apply(this, arguments);
      }

      return showNotificationModal;
    }()
  }]);

  return NotificationPresenter;
}();

var notificationPresenter = new NotificationPresenter();

function checkNotificationSupport(notification) {
  switch (notification.type) {
    case 're.notifica.notification.None':
    case 're.notifica.notification.Alert':
    case 're.notifica.notification.Image':
    case 're.notifica.notification.InAppBrowser':
    case 're.notifica.notification.Map':
    case 're.notifica.notification.Passbook':
    case 're.notifica.notification.URL':
    case 're.notifica.notification.URLResolver':
    case 're.notifica.notification.URLScheme':
    case 're.notifica.notification.Video':
    case 're.notifica.notification.WebView':
      return true;

    default:
      return false;
  }
}

function presentInAppBrowser(notification) {
  var content = notification.content.find(function (_ref6) {
    var type = _ref6.type;
    return type === 're.notifica.content.URL';
  });
  if (!content) throw new Error('Invalid notification content.');
  window.location.href = sanitizeContentUrl(content);
}

function presentPassbook(_x27, _x28) {
  return _presentPassbook.apply(this, arguments);
}

function _presentPassbook() {
  _presentPassbook = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(options, notification) {
    var content, passUrlStr, components, id, _yield$fetchCloudPass, pass, _yield$fetchCloudPass2, saveLinks;

    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            content = notification.content.find(function (_ref13) {
              var type = _ref13.type;
              return type === 're.notifica.content.PKPass';
            });

            if (content) {
              _context24.next = 3;
              break;
            }

            throw new Error('Invalid notification content.');

          case 3:
            passUrlStr = content.data;
            components = passUrlStr.split('/');

            if (components.length) {
              _context24.next = 7;
              break;
            }

            throw new Error('Invalid notification content.');

          case 7:
            id = components[components.length - 1];
            _context24.next = 10;
            return fetchCloudPass({
              environment: getCloudApiEnvironment(),
              serial: id
            });

          case 10:
            _yield$fetchCloudPass = _context24.sent;
            pass = _yield$fetchCloudPass.pass;

            if (!(pass.version === 2)) {
              _context24.next = 23;
              break;
            }

            _context24.next = 15;
            return fetchCloudPassSaveLinks({
              environment: getCloudApiEnvironment(),
              serial: id
            });

          case 15:
            _yield$fetchCloudPass2 = _context24.sent;
            saveLinks = _yield$fetchCloudPass2.saveLinks;

            if (!(isAppleDevice() && isSafariBrowser() && (saveLinks === null || saveLinks === void 0 ? void 0 : saveLinks.appleWallet))) {
              _context24.next = 20;
              break;
            }

            window.location.href = saveLinks.appleWallet;
            return _context24.abrupt("return");

          case 20:
            if (!(saveLinks === null || saveLinks === void 0 ? void 0 : saveLinks.googlePay)) {
              _context24.next = 23;
              break;
            }

            window.location.href = saveLinks.googlePay;
            return _context24.abrupt("return");

          case 23:
            if (!(isAppleDevice() && isSafariBrowser())) {
              _context24.next = 26;
              break;
            }

            window.location.href = "https://".concat(options.hosts.restApi, "/pass/pkpass/").concat(id);
            return _context24.abrupt("return");

          case 26:
            window.location.href = "https://".concat(options.hosts.restApi, "/pass/web/").concat(id, "?showWebVersion=1");

          case 27:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _presentPassbook.apply(this, arguments);
}

function presentUrlScheme(_x29) {
  return _presentUrlScheme.apply(this, arguments);
}

function _presentUrlScheme() {
  _presentUrlScheme = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(notification) {
    var content, urlStr, url, link;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            content = notification.content.find(function (_ref14) {
              var type = _ref14.type;
              return type === 're.notifica.content.URL';
            });

            if (content) {
              _context25.next = 3;
              break;
            }

            throw new Error('Invalid notification content.');

          case 3:
            if (!(!content.data || !content.data.trim())) {
              _context25.next = 6;
              break;
            }

            window.location.href = '/';
            return _context25.abrupt("return");

          case 6:
            urlStr = content.data.trim();
            _context25.prev = 7;
            url = new URL(urlStr);
            _context25.next = 16;
            break;

          case 11:
            _context25.prev = 11;
            _context25.t0 = _context25["catch"](7);
            logger.error("Unable to parse URL string '".concat(urlStr, "'."), _context25.t0);
            window.location.href = urlStr;
            return _context25.abrupt("return");

          case 16:
            if (url.host.endsWith('ntc.re')) {
              _context25.next = 19;
              break;
            }

            window.location.href = urlStr;
            return _context25.abrupt("return");

          case 19:
            _context25.next = 21;
            return fetchDynamicLink(urlStr);

          case 21:
            link = _context25.sent;
            window.location.href = link.target;

          case 23:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25, null, [[7, 11]]);
  }));
  return _presentUrlScheme.apply(this, arguments);
}

function presentNotification(notification) {
  notificationPresenter.present(notification);
}

function presentAction(notification, action) {
  presentAction$1(notification, action);
}

registerComponents();
export { onActionExecuted, onActionFailedToExecute, onActionWillExecute, onCustomActionReceived, onNotificationFailedToPresent, onNotificationFinishedPresenting, onNotificationPresented, onNotificationWillPresent, presentAction, presentNotification };